import { SocialType } from "../../../model/common/social"
import "./talent-landing-reel.scss"
import avatar1 from "../../../assets/images/avatars/ToyFaces_Colored_BG_2.jpg"
import avatar2 from "../../../assets/images/avatars/ToyFaces_Colored_BG_33.jpg"
import avatar3 from "../../../assets/images/avatars/ToyFaces_Colored_BG_12.jpg"
import avatar4 from "../../../assets/images/avatars/ToyFaces_Colored_BG_44.jpg"
import avatar5 from "../../../assets/images/avatars/ToyFaces_Colored_BG_32.jpg"
import avatar6 from "../../../assets/images/avatars/ToyFaces_Colored_BG_8.jpg"
import avatar7 from "../../../assets/images/avatars/ToyFaces_Colored_BG_16.jpg"
import avatar8 from "../../../assets/images/avatars/ToyFaces_Colored_BG_22.jpg"
import avatar9 from "../../../assets/images/avatars/ToyFaces_Colored_BG_10.jpg"
import avatar10 from "../../../assets/images/avatars/ToyFaces_Colored_BG_67.jpg"
import avatar11 from "../../../assets/images/avatars/ToyFaces_Colored_BG_69.jpg"
import avatar12 from "../../../assets/images/avatars/ToyFaces_Colored_BG_51.jpg"
import { useEffect, useRef } from "react"



import { motion, useAnimation, useInView } from "framer-motion"
import FacebookIcon from "../../../components/icon/facebook-icon"
import InstagramIcon from "../../../components/icon/instagram-icon"
import Star1Icon from "../../../components/icon/star1-icon"
import TikTokIcon from "../../../components/icon/tiktok-icon"
import TwitterIcon from "../../../components/icon/twitter-icon"
import YoutubeIcon from "../../../components/icon/youtube-icon"
import { Color } from "../../../utilities/colors"

const boxVariant = {
    visible: { opacity: 1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, }
};


const TalentLandingReel = (props: any) => {

    const reelRef = useRef<HTMLDivElement>(null)

    // Animation Props
    const control = useAnimation();
    const inView = useInView(reelRef);

    const data: TalentDemoCardType[] = [
        {
            displayImg: avatar1,
            talentName: "John Doe",
            representative: "Jane Smith",
            avgPrice: "$200",
            reach: "10,000",
            ratingAvg: "4.5",
            ratingCount: "20",
            country: "United States",
            socialPlatforms: new Set(["facebook", "instagram", "twitter"] as SocialType[])
        },
        {
            displayImg: avatar2,
            talentName: "Emily Johnson",
            representative: "John Davis",
            avgPrice: "$500",
            reach: "50,000",
            ratingAvg: "4.0",
            ratingCount: "30",
            country: "Canada",
            socialPlatforms: new Set(["instagram", "twitter", "tiktok"] as SocialType[])
        },
        {
            displayImg: avatar3,
            talentName: "Michael Brown",
            representative: "Emily Wilson",
            avgPrice: "$300",
            reach: "25,000",
            ratingAvg: "3.5",
            ratingCount: "10",
            country: "United Kingdom",
            socialPlatforms: new Set(["facebook", "twitter", "youtube"] as SocialType[])
        },
        {
            displayImg: avatar4,
            talentName: "Jessica Smith",
            representative: "Michael Thompson",
            avgPrice: "$1000",
            reach: "100,000",
            ratingAvg: "5.0",
            ratingCount: "40",
            country: "Australia",
            socialPlatforms: new Set(["instagram", "tiktok", "youtube"] as SocialType[])
        },
        {
            displayImg: avatar5,
            talentName: "Jacob Garcia",
            representative: "Jessica Martinez",
            avgPrice: "$150",
            reach: "5,000",
            ratingAvg: "3.0",
            ratingCount: "15",
            country: "Spain",
            socialPlatforms: new Set(["facebook", "instagram"] as SocialType[])
        },
        {
            displayImg: avatar6,
            talentName: "Isabella Perez",
            representative: "Jacob Rodriguez",
            avgPrice: "$400",
            reach: "40,000",
            ratingAvg: "4.5",
            ratingCount: "25",
            country: "Brazil",
            socialPlatforms: new Set(["instagram", "twitter"] as SocialType[])
        },
        {
            displayImg: avatar7,
            talentName: "Sophia Lee",
            representative: "Isabella Lewis",
            avgPrice: "$800",
            reach: "80,000",
            ratingAvg: "4.0",
            ratingCount: "35",
            country: "China",
            socialPlatforms: new Set(["facebook", "tiktok"] as SocialType[])
        },
        {
            displayImg: avatar8,
            talentName: "Mia Wang",
            representative: "Sophia Zhang",
            avgPrice: "$600",
            reach: "60,000",
            ratingAvg: "3.5",
            ratingCount: "20",
            country: "Japan",
            socialPlatforms: new Set(["instagram", "youtube"] as SocialType[])
        },
        {
            displayImg: avatar9,
            talentName: "Jacob Green",
            representative: "Mia Green",
            avgPrice: "$700",
            reach: "70,000",
            ratingAvg: "4.0",
            ratingCount: "25",
            country: "France",
            socialPlatforms: new Set(["twitter", "tiktok", "youtube"] as SocialType[])
        },
        {
            displayImg: avatar10,
            talentName: "Ethan White",
            representative: "Emily Harris",
            avgPrice: "$350",
            reach: "35,000",
            ratingAvg: "3.5",
            ratingCount: "15",
            country: "Germany",
            socialPlatforms: new Set(["facebook", "instagram"] as SocialType[])
        },
        {
            displayImg: avatar11,
            talentName: "Madison Moore",
            representative: "Madison Taylor",
            avgPrice: "$450",
            reach: "45,000",
            ratingAvg: "4.0",
            ratingCount: "20",
            country: "India",
            socialPlatforms: new Set(["instagram", "twitter", "youtube"] as SocialType[])
        },
        {
            displayImg: avatar12,
            talentName: "Avery Turner",
            representative: "Avery Cook",
            avgPrice: "$250",
            reach: "25,000",
            ratingAvg: "3.0",
            ratingCount: "10",
            country: "Italy",
            socialPlatforms: new Set(["facebook", "tiktok"] as SocialType[])
        }
    ]



    const refs = useRef<null[] | HTMLDivElement[]>([]);
    const relRef = useRef<HTMLDivElement | null>(null)
    const relRef2 = useRef<HTMLDivElement | null>(null)

    const isAnimating = useRef<boolean>(false)

    useEffect(() => {
        startTimer()
    }, [])

    useEffect(() => {
        if (isAnimating.current) return
        if (inView) {
            isAnimating.current = true
            control.start("visible");
            setTimeout(() => {
                relRef.current?.classList.add("move")
                relRef2.current?.classList.add("move")
            }, 1000)

        }
    }, [inView, control])


    const startTimer = () => {
        setInterval(() => {

            if (relRef2.current === null) return;
            if (relRef2.current.getBoundingClientRect().left < 0) {
                // Remove Animation to reset 100% index
                relRef.current?.classList.remove("move")
                relRef2.current?.classList.remove("move")
                // Add animation to show infinite scroll
                relRef.current?.classList.add("move")
                relRef2.current?.classList.add("move")
            }

        }, 100);
    }

    return (
        <motion.div
            ref={reelRef}
            variants={boxVariant}
            initial="hidden"
            animate={control}
        >
            <div className="h-stack reel-wrapper" >
                <div className="left"></div>
                <div className="right"></div>
                <div ref={relRef} className="animated-reel move">
                    {data.map((record, index) => {
                        return (
                            <div key={index} ref={(el) => (refs.current[index] = el)} className="card-wrapper">
                                <TalentDemoCard
                                    key={index}
                                    cardInfo={record} />
                            </div>
                        )
                    })}
                </div>
                <div ref={relRef2} className="animated-reel move">
                    {data.map((record, index) => {
                        return (
                            <div key={index} ref={(el) => (refs.current[index] = el)} className="card-wrapper">
                                <TalentDemoCard
                                    key={index}
                                    cardInfo={record} />
                            </div>
                        )
                    })}
                </div>
            </div>
        </motion.div>

    )
}
export default TalentLandingReel




export interface TalentDemoCardType {
    displayImg: string;
    talentName: string;
    representative: string;
    avgPrice: string;
    reach: string;
    ratingAvg: string;
    ratingCount: string;
    country: string;
    socialPlatforms: Set<SocialType>
}

interface IProp {
    cardInfo: TalentDemoCardType
}
const TalentDemoCard = (props: IProp) => {

    const { cardInfo } = props

    return (<div className="talent-card">
        <img src={cardInfo.displayImg} alt="Avatar 1" />
        <div className="details-wrapper">
            <div className="p-3">
                <span className="name">{cardInfo.talentName}</span>
                <span className="representative mt-2">{cardInfo.representative}</span>
            </div>
            <hr className="bg-gray-750 m-0" />
            <div className="p-3">
                <div className="h-stack">
                    <div className="metric-wrapper">
                        <span className="metric-label">Avg Price</span>
                        <span className="metric mt-1">{cardInfo.avgPrice}</span>
                    </div>
                    <div className="metric-wrapper">
                        <span className="metric-label">Reach</span>
                        <span className="metric mt-1">{cardInfo.reach}</span>
                    </div>
                </div>
                <div className="h-stack mt-3">
                    <div className="metric-wrapper">
                        <div>
                            <span className="metric-label">Rating</span>
                            <div className="rating-wrapper">
                                <span className="metric mt-1">{cardInfo.ratingAvg}&nbsp;</span>
                                <Star1Icon backgroundColor="#ffc107" top={2} size={12} />
                                <span className="metric mt-1">&nbsp;({cardInfo.ratingCount})</span>
                            </div>
                        </div>
                    </div>
                    <div className="metric-wrapper">
                        <span className="metric-label">Country</span>
                        <span className="metric mt-1">{cardInfo.country}</span>
                    </div>
                </div>
            </div>
            <hr className="bg-gray-750 m-0" />
            <div className="p-3">
                <div className="h-stack icon-wrapper">
                    <div>
                        <FacebookIcon backgroundColor={Color.NEUTRAL[500]} top={2} size={12} />
                    </div>
                    <div>
                        <TwitterIcon backgroundColor={Color.NEUTRAL[500]} top={2} size={12} />

                    </div>
                    <div>
                        <TikTokIcon backgroundColor={Color.NEUTRAL[500]} top={2} size={12} />
                    </div>
                    <div>
                        <InstagramIcon backgroundColor={Color.NEUTRAL[500]} top={2} size={12} />
                    </div>
                    <div>
                        <YoutubeIcon backgroundColor={Color.NEUTRAL[500]} top={2} size={12} />
                    </div>
                </div>
            </div>
        </div>
    </div>)
}